import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styles from './CustomConfirmAlert.module.css';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const CustomConfirmAlert = observer(function CustomConfirmAlert(props) {
  const {
    title,
    message,
    falseText,
    falseEvent,
    trueText,
    trueEvent,
    customComponent,
    customStyles,
    commonStore,
    additionalStyles,
  } = props;

  function executeTrueEventAndClose() {
    trueEvent();
    falseEvent();
  }

  return (
    <Grid
      component="div"
      container
      className={styles.confirmAlertContainer}
      style={customStyles || null}
    >
      {title || commonStore?.customModalTitle ? (
        <Grid component="div" item xs={12} align="center">
          <span
            style={additionalStyles?.customAlertTitle || null}
            className={styles.confirmAlertTitle}
            data-testid="alertTitle"
          >
            {title || commonStore?.customModalTitle}
          </span>
        </Grid>
      ) : null}

      {message ? (
        <Grid component="div" item xs={12} align="center">
          <span className={styles.confirmAlertText} data-testid="alertText">
            {message}
          </span>
        </Grid>
      ) : null}

      {customComponent ? (
        <Grid component="div" item xs={12} align="center">
          {React.cloneElement(customComponent, { commonStore })}
        </Grid>
      ) : null}

      {trueEvent && trueText ? (
        <React.Fragment>
          <Grid component="div" item xs={6} align="center" className={styles.shortBorder}>
            <button
              type="button"
              onClick={executeTrueEventAndClose}
              style={additionalStyles?.customAlertButton || null}
              className={styles.confirmAlertButton}
              data-testid="trueEvent"
            >
              {trueText}
            </button>
          </Grid>

          <Grid component="div" item xs={6} align="center">
            <button
              type="button"
              onClick={falseEvent}
              style={additionalStyles?.customAlertButton || null}
              className={styles.confirmAlertButton}
              data-testid="falseEvent"
            >
              {falseText}
            </button>
          </Grid>
        </React.Fragment>
      ) : (
        <Grid component="div" item xs={12} align="center">
          <button
            type="button"
            onClick={falseEvent}
            style={additionalStyles?.customAlertButton || null}
            className={styles.confirmAlertButton}
            data-testid="falseEventOnly"
          >
            {falseText}
          </button>
        </Grid>
      )}
    </Grid>
  );
});
CustomConfirmAlert.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  falseText: PropTypes.string.isRequired,
  falseEvent: PropTypes.func.isRequired,
  trueText: PropTypes.string,
  trueEvent: PropTypes.func,
};
CustomConfirmAlert.whyDidYouRender = true;
CustomConfirmAlert.displayName = 'CustomConfirmAlert';

export default CustomConfirmAlert;
